// 请注意, 大部分接口都在imageGroup.js 因为共用了
import request from '@/utils/request'

/**
 * @description 通用视频上传接口
 * @param data
 */
export function uploadVideoAPI(data) {
  return request.post('/phalapi/public/?service=App.Common.SaveVideo', data)
}
